<template>
  <div class="checkbox">
    <label :for="`checkbox${index}`" class="checkbox_label">
      <a
        :href="builtQueryString"
        :title="attribute.attributeName"
        class="active"
      >
        <span>{{ attribute.attributeName }}</span>
        <i class="lni lni-close"></i>
      </a>
    </label>
  </div>
</template>

<script>
import AttributeListingFiltersModel from './attributes/filters/Models/AttributeListingFiltersModel'
import { mapGetters } from 'vuex'

export default {
  name: 'AdvListingUsedAttribute',
  props: {
    group: {
      attributeDisplayType: '',
      attributeGroupId: '',
      attributeGroupName: null,
      attributeGroupStep: 0,
      attributeGroupDisplayPosition: 0,
      attributes: []
    },
    attribute: {
      attributeDisplayValue: '',
      attributeId: '',
      attributeName: ''
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'getUriWithoutOffset',
      'getAttributeFilterQueryStringVar',
      'getActiveAttributeFilters',
      'getIsTopLevelCategory',
      'getCurrentPageNumber',
      'getActiveVariationFiltersString',
      'getActiveTagFiltersString',
      'config'
    ]),
    builtQueryString () {
      return this.filteringManage(this.group, this.attribute)
    },
    activeFiltersString () {
      const tagFiltersString = this.getActiveTagFiltersString
      const variationFiltersString = this.getActiveVariationFiltersString
      if (tagFiltersString !== '' && variationFiltersString !== '') {
        return tagFiltersString + '&' + variationFiltersString
      }
      if (tagFiltersString !== '') {
        return tagFiltersString
      }
      if (variationFiltersString !== '') {
        return variationFiltersString
      }
      return ''
    }
  },
  methods: {
    filteringManage (group, entry) {
      const isFilterUsed = true
      const duplicateAttributeGroupNamesPerGroup = {}
      return new AttributeListingFiltersModel(
        this.getUriWithoutOffset,
        this.getAttributeFilterQueryStringVar,
        this.getActiveAttributeFilters,
        this.getIsTopLevelCategory,
        this.getCurrentPageNumber,
        this.config.url.lang,
        this.activeFiltersString,
        duplicateAttributeGroupNamesPerGroup
      ).createLinkQueryStringFinal(group, entry, isFilterUsed)
    }
  }
}

</script>

<style lang="scss" scoped>
.prod_list_header_filters {
  display: grid;
  grid-template-columns: auto auto auto;
  align-items: center;
  margin-bottom: 45px;
}
.checkbox {
  position: relative;
  width: 100%;
  display: grid;
  margin: 0;
  border: 1px solid black;
  border-radius: 8px;
  font-size: 14px;
  padding: 0 10px;
  line-height: 1.2;
  font-weight: 500;
  height: 40px;
  .checkbox_label {
    display: flex;
    padding: 0 10px;
    cursor: pointer;
    color: black;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.3;
    height: 100%;
    align-items: center;
    align-content: center;
    margin: 0;
    @media screen and (max-width: 992px) {
      font-size: 13px;
    }
    &:before{
      display: none
    }
    a {
      display: grid;
      gap: 5px;
      grid-template-columns: 1fr auto;
      align-items: center;
      @media screen and (max-width: 992px) {
        color: #000000;
        font-weight: normal;
      }
      i {
        color: var(--prime2);
      }
    }
  }
  .checkbox_input:checked+.checkbox_label::before {
    display: none
  }
}
.native_slider-lg {
  border-right: 1px solid #707070;
}
</style>
